import { render, staticRenderFns } from "./charger-status-details.vue?vue&type=template&id=53946d2e"
import script from "./charger-status-details.vue?vue&type=script&lang=js"
export * from "./charger-status-details.vue?vue&type=script&lang=js"
import style0 from "./charger-status-details.vue?vue&type=style&index=0&id=53946d2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports